// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.63f2407c6.chunk.js";
	if (chunkId === 12) return "static/js/profiler.63f2407c6.chunk.js";
	if (chunkId === 740) return "static/js/740.63f2407c6.chunk.js";
	if (chunkId === 597) return "static/js/597.63f2407c6.chunk.js";
	if (chunkId === 60) return "static/js/60.63f2407c6.chunk.js";
	if (chunkId === 625) return "static/js/625.63f2407c6.chunk.js";
	if (chunkId === 227) return "static/js/227.63f2407c6.chunk.js";
	if (chunkId === 512) return "static/js/512.63f2407c6.chunk.js";
	if (chunkId === 763) return "static/js/763.63f2407c6.chunk.js";
	if (chunkId === 817) return "static/js/817.63f2407c6.chunk.js";
	if (chunkId === 87) return "static/js/87.63f2407c6.chunk.js";
	if (chunkId === 945) return "static/js/945.63f2407c6.chunk.js";
	if (chunkId === 978) return "static/js/978.63f2407c6.chunk.js";
	if (chunkId === 71) return "static/js/71.63f2407c6.chunk.js";
	if (chunkId === 103) return "static/js/103.63f2407c6.chunk.js";
	if (chunkId === 393) return "static/js/393.63f2407c6.chunk.js";
	if (chunkId === 177) return "static/js/177.63f2407c6.chunk.js";
	if (chunkId === 292) return "static/js/292.63f2407c6.chunk.js";
	if (chunkId === 874) return "static/js/874.63f2407c6.chunk.js";
	if (chunkId === 91) return "static/js/91.63f2407c6.chunk.js";
	if (chunkId === 142) return "static/js/142.63f2407c6.chunk.js";
	if (chunkId === 497) return "static/js/497.63f2407c6.chunk.js";
	if (chunkId === 599) return "static/js/599.63f2407c6.chunk.js";
	if (chunkId === 300) return "static/js/300.63f2407c6.chunk.js";
	if (chunkId === 698) return "static/js/698.63f2407c6.chunk.js";
	// return url for filenames based on template
	return undefined;
};